<template>
  <b-overlay :show="loading" rounded="sm">
    <b-card class="product-item">
      <h4 v-text="editing ? 'ویرایش محصول' : 'محصول جدید'" class="mb-2" />
      <b-row>
        <b-col md="12" lg="8" offset-lg="2">
          <b-row>
            <b-col md="6">
              <b-form-group
                  label="عنوان"
              >
                <b-form-input
                    v-model="form.Title"
                    autocomplete="off"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                  label="مسیر"
              >
                <b-form-input
                    v-model="form.Route"
                    autocomplete="off"
                    type="tel"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                  label="کد رنگ"
              >
                <b-form-input
                    v-model="form.Color"
                    autocomplete="off"
                    type="tel"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                  label="وضعیت"
                  class="flex-grow-1 m-0"
              >
                <v-select
                    v-model="form.Status"
                    name="Status"
                    dir="rtl"
                    :reduce="x => x.value"
                    label="text"
                    input-id="Status"
                    :clearable="false"
                    :options="enums('productStatus')"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="meta title">
                <b-form-input v-model="form.MetaTitle" />
              </b-form-group>
            </b-col>
             <b-col md="12">
              <b-form-group label="alt image">
                <b-form-input v-model="form.Alt" />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                  label="meta description"
              >
                <b-form-textarea
                    v-model="form.MetaDescription"
                    autocomplete="off"
                    no-resize
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="توضیحات کوتاه">
                <b-form-textarea
                    v-model="form.ShortDescription"
                    autocomplete="off"
                    no-resize
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="توضیحات ویدئو">
                <b-form-textarea
                    v-model="form.VideoDescription"
                    autocomplete="off"
                    no-resize
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                  label="توضیحات"
                  label-for="Description"
              >
                <div class="form-label-group">
                  <b-form-textarea
                      id="Description"
                      v-model="form.Description"
                      name="Description"
                      autocomplete="off"
                      rows="15"
                  />
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="mt-2">
            <div class="d-flex align-items-center">
              <b-form-group
                  label="ویژگی ها"
                  class="flex-grow-1"
              >
                <b-form-input
                    v-model="property"
                    autocomplete="off"
                />
              </b-form-group>
              <b-button class="btn-icon mt-1 ml-1" variant="primary" size="sm" @click="addProperty">
                <feather-icon icon="PlusIcon" />
              </b-button>
            </div>
            <div v-if="propertyItems.length" class="p-1 rounded" style="background-color: #f5f5f5">
              <div v-for="(property, index) in propertyItems" :key="index" class="d-flex align-items-center mb-1">
                <b-form-input
                    v-model="propertyItems[index]"
                    autocomplete="off"
                />
                <b-button class="btn-icon ml-1" variant="outline-danger" size="sm" @click="deleteProperty(index)">
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <b-row
                v-for="(item, index) in Faqs"
                :key="index"
                ref="FAQ"
                class="w-auto border-1 border-primary p-2 rounded-lg mb-2" >
              <div class="w-100">
                <div class="float-right">
                  <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-danger"
                      class="btn-icon rounded-circle"
                      @click="Faqs.splice(index,1)"
                  >
                    <feather-icon
                        icon="TrashIcon"
                    />
                  </b-button>
                </div>
              </div>

              <b-col md="12">
                <b-form-group
                    label="سوال"
                    label-for="Title"
                >
                  <b-form-textarea
                      id="Title"
                      v-model="item.Title"
                      name="metaDescription"
                      rows="2"
                      no-resize
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                    label="پاسخ"
                    label-for="metaDescription"
                >
                  <b-form-textarea
                      id="metaDescription"
                      v-model="item.Description"
                      name="metaDescription"
                      rows="2"
                      no-resize
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="gradient-info"
                class="mb-1"
                @click="addFAQ()"
            >
              <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
              />
              <span>Faq افزودن</span>
            </b-button>
          </div>
          <b-row class="mt-3">
            <b-col md="12" class="mb-1">
              <fm-file-select v-model="form.Icon" label="ایکون" :entity="entity" />
            </b-col>
            <b-col md="12" class="mb-1">
              <fm-file-select v-model="form.Image" label="عکس" :entity="entity" />
            </b-col>
            <b-col md="12" class="mb-1">
              <fm-file-select v-model="form.ProductImage" label="هدر محصول" :entity="entity" />
            </b-col>
            <b-col md="12" class="mb-1">
              <fm-file-select v-model="form.Video" label="ویدئو" type="video" :entity="entity" />
            </b-col>
          </b-row>
          <div class="d-flex align-items-center justify-content-center mt-4">
            <b-button variant="primary" class="mr-1" @click="submit">
              ذخیره
            </b-button>
            <b-button :to="{ name: 'products'}">
              بازگشت
            </b-button>
          </div>
        </b-col>
      </b-row>

    </b-card>
  </b-overlay>
</template>

<script>
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue";

const ENTITY_SLIDER = 13

export default {
  name: "productItem",
  components: { FmFileSelect },
  data() {
    return {
      loading: false,
      entity: ENTITY_SLIDER,
      Faqs:[
        {
          Description:null,
          Title:null,
        }
      ],
      form: {
        Title: '',
        Route: '',
        Color: '',
        MetaTitle: '',
        Alt:'',
        MetaDescription: '',
        ShortDescription: '',
        VideoDescription: '',
        Description: '',
        Status: 1,
        Icon: null,
        Image: null,
        Video: null,
        ProductImage: null,
        PropertyList: []
      },
      property: '',
      propertyItems: [],
    }
  },
  computed: {
    editing() {
      return this.$route.params.id
    }
  },
  watch: {
    editing: {
      immediate: true,
      handler(val) {
        if (val !== '' && val !== undefined) this.get()
      }
    }
  },
  methods: {
    get() {
      this.loading = true
      this.$http.get(
          this.$api.product.get, {
            params: { id: this.editing, }
          },
      )
          .then(res => {
            this.loading = false
            this.form = res.data
            this.propertyItems = res.data.PropertyList
            if(res.data.BlogProductionFaqs.length)
            this.Faqs = res.data.BlogProductionFaqs
          }).catch(() => {
        this.loading = false
      })
    },
    submit() {
      for (let i in this.form) {
        if (this.form[i] === '' || this.form[i] === null)
          return this.$bvToast.toast('لطفا همه فیلد ها را پر کنید', {
            title: 'خطا در انجام عملیات',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
            solid: false,
            appendToast: true,
          })
      }

      let url
      this.loading = true

      if (this.editing) url = this.$api.product.edit
      else url = this.$api.product.add

      const form = {
        ...this.form,
        ...(this.editing && { Id: this.editing }),
        PropertyList: this.propertyItems.join(';'),
        BlogProductionFaqs: this.Faqs
      }

      this.$http.post(url, form)
          .then(() => {
            this.loading = false
            this.$router.back()
          }).catch(() => {
        this.loading = false
      })
    },
    addProperty() {
      if (this.property) {
        this.propertyItems.push(this.property)
        this.property = ''
      }
    },
    deleteProperty(index) {
      this.propertyItems.splice(index, 1)
    },
    addFAQ(){
      this.Faqs.push({
        Description:'',
        Title:'',
      })
    }
  }
}
</script>